import { ITranslations } from 'types/common';
import { CatalogueRequestFormTransFields } from './types';
import en from 'translations/en/catalogueRequestForm.json';
import pl from 'translations/pl/catalogueRequestForm.json';
import sl from 'translations/sl/catalogueRequestForm.json';

export const catalogueRequestFormTranslations: ITranslations<CatalogueRequestFormTransFields> = {
  name: 'catalogueRequestForm',
  en,
  pl,
  sl,
};
